var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__info--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 3a9 9 0 11-9 9 9 9 0 019-9m0-2a11 11 0 1011 11A11 11 0 0012 1zm-1.015 7a1 1 0 101-1 1 1 0 00-1 1zM13 16v-4.5a1 1 0 00-2 0V16a1 1 0 002 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }